import DataTables from "datatables.net-dt";

import React, { useState } from 'react'
import { useEffect } from "react";
import 'jquery/dist/jquery.slim';
import 'datatables.net-responsive-bs4';
import 'datatables.net-scroller-bs4';
import  $  from 'jquery';
import moment from 'moment';


const DatatableComponent = ({items, deleteAction, updateAction, _tableType}) => {

    const [dataArray] = useState(items);
    const [tableType] = useState(_tableType);


    useEffect(() => {
            if(!$.fn.DataTable.isDataTable("#p-table")) {
                new DataTables("#p-table", {
                    language: {
                        url: "//cdn.datatables.net/plug-ins/1.10.24/i18n/French.json"
                    },
                    order: [ 2, 'desc' ],
                    scrollX: true,  
                    scrollY: true,
                    scroll: true,
                    info: false,
                    searching: items.length > 0 ? true : false,
                    paging: items.length > 0 ? true : false,
                    dom: '<"row justify-content-end"<"col-sm-12 col-md-3"l><"col-sm-12 col-md-3"f>><"row" <"col-lg-12" rt>><"row" <"col-lg-12 d-flex justify-content-end" ip>>',

                });
               }
    }, [items])

  return (
    <table  className="table table-borderd table-hover w-100" id="p-table">
       {tableType === "payment" && (
         <>
         <thead>
                  <tr>
                    <th scope="col">Nom</th>
                    <th scope="col">Montant</th>
                    <th scope="col">Date de paiement</th>
                    <th scope="col">Id Worldline</th>
                    <th scope="col">Statut</th>
                  </tr>
              </thead>
            <tbody>
                      {dataArray && dataArray.length > 0 && (
                          dataArray.map((val, key) => (
                              <tr key={val.id} itemScope='row'>
                                <td>{val.name}</td>
                                <td>{val.amount} &euro;</td>
                                <td>{moment(val.createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                                <td>{val.wlId}</td>
                                <td>{val.status*1===1 ? "Validé" : "Non validé" }</td>
                              </tr>
                          ))
                      )}
            </tbody>
        </>)}
       {tableType === "agents" && (
         <>
         <thead>
                  <tr>
                      <th scope="col">Login</th>
                      <th scope="col">Email</th>
                      <th scope="col">Rôle</th>
                      <th scope="col">Service</th>
                      <th scope="col">Actions</th>
                  </tr>
              </thead>
            <tbody>
                      {dataArray && dataArray.length > 0 && (
                          dataArray.map((val, key) => (
                              val.id !== 101 ?
                              <tr key={val.id} itemScope='row'>
                                  <td>{val.userName}</td>
                                  <td>{val.email}</td>
                                  <td>{val.roles[0] === "ROLE_CUSTOMER" ? "Client" : (val.roles[0] === "ROLE_ADMIN") ? "Admin" : (val.roles[0] === "ROLE_SUPER_AGENT" ? "Superviseur agent interne" : "Agent interne")}</td>
                                  <td>{val.service}</td>
                                  <td>
                                      <button data-id={val.id} onClick={updateAction}
                                              className="btn btn-primary mr-2">Modifier
                                      </button>
                                      <button data-id={val.id} onClick={deleteAction}
                                              className="btn btn-danger">Supprimer
                                      </button>
                                  </td>
                              </tr>: ""

                          ))
                      ) }
            </tbody>
        </>)}

        {tableType === "recovery_stage" && (
            <>
                <thead>
                <tr>
                    <th style={{ textAlign: "left" }} scope="col">Process</th>
                    <th style={{ textAlign: "left" }} scope="col">Durée</th>
                    <th style={{ textAlign: "left" }} scope="col">Vision agent</th>
                    <th style={{ textAlign: "left" }} scope="col">Vision client</th>
                    <th style={{ textAlign: "left" }} scope="col">Date</th>
                    <th style={{ textAlign: "left" }} scope="col">statut</th>
                </tr>
                </thead>
                <tbody>
                {dataArray && dataArray.length > 0 && (
                    dataArray.map((val, key) => (
                            <tr key={val.id} itemScope='row'>
                                <td>{val.processtypename}</td>
                                <td>{val.delayLimit}</td>
                                <td>{val.visionAgent}</td>
                                <td>{val.visionClient}</td>
                                <td>{moment(val.createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                                <td>{val.status===1 ? "Valide" :  "Archive"}</td>

                            </tr>

                    ))
                ) }
                </tbody>
            </>)}

        {tableType === "recovery_rules" && (
            <>
                <thead>
                <tr>
                    <th style={{ textAlign: "left" }} scope="col">Nom</th>
                    <th style={{ textAlign: "left" }} scope="col">Valeur</th>
                    <th style={{ textAlign: "left" }} scope="col">Date</th>
                    <th style={{ textAlign: "left" }} scope="col">statut</th>

                </tr>
                </thead>
                <tbody>
                {dataArray && dataArray.length > 0 && (
                    dataArray.map((val, key) => (
                        <tr key={val.id} itemScope='row'>
                            <td>{val.name}</td>
                            <td>{val.value}</td>
                            <td>{moment(val.createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>{val.status===1 ? "Valide" :  "Archive"}</td>

                        </tr>

                    ))
                ) }
                </tbody>
            </>)}


    </table>
  )
}

export default DatatableComponent;




